import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  DEBTORS_SUMMARY_REQUEST: (payload) => payload,
  DEBTORS_DETAIL_REQUEST: (payload) => payload,
  DEBTORS_SUCCESS: (payload) => payload,
  DEBTORS_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const detailReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    DEBTORS_SUMMARY_REQUEST: summaryReducer,
    DEBTORS_DETAIL_REQUEST: detailReducer,
    DEBTORS_SUCCESS: successReducer,
    DEBTORS_FAILURE: failureReducer,
  },
  initState,
);
